export enum RootRoute {
  agentic = 'agentic',
  canvas = 'canvas',
  intents = 'intents',
  save = 'save',
  settings = 'settings',
  testTool = 'testTool'
}
